<section class="bar-graph bar-graph-horizontal bar-graph-one" [style.height.%]="80">
  @for (shareholder of shareholders; track shareholder) {
    <div class="bar-one my-1" style="background-color: #e2e8f0" [style.height.%]="100" [style.min-height.em]="1.7">
      <div class="bar" [style.height.%]="100" [style.min-height.em]="1.7" [style.width.%]="shareholder.width"></div>
      <div
        class="barchart-text flex items-center"
        style="color: #6c757d !important; position: absolute; padding-left: 2%">
        {{ shareholder?.value | number: '1.1-1' }} % {{ shareholder?.name }}
      </div>
    </div>
  }
  <div class="bar-one my-1" style="background-color: #e2e8f0" [style.height.%]="100" [style.min-height.em]="1.7">
    <div
      class="bar"
      style="background-color: var(--color-brand-200)"
      [style.height.%]="100"
      [style.min-height.em]="1.7"
      [style.width.%]="freefloatWidth"></div>
    <div
      class="barchart-text flex items-center"
      style="color: #6c757d !important; position: absolute; padding-left: 2%">
      {{ freefloat | number: '1.1-1' }} % Freefloat
    </div>
  </div>
</section>
